export enum EditableListRemoveStrategy {
    ALWAYS = "Always",
    ONLY_NEW = "OnlyNew",
    NEVER = "Never",
}
